import {standardAjaxPost, standardAjaxErrorCallback} from "stdjs/standard-ajax";
import Translator from '../stdjs/translate-service';

/**
 * USAGE
 * 
 * In the HTML create a .tabContainer. This is the container that will hold
 * the tab bar and the tab pages. Pass this element in as the selector argument.
 * 
 * Somewhere inside the .tabContainer, create a .tabBar containing .tabItems.
 * On each .tabItem, set "data-tab-id" = a unique string.
 * 
 * This string must be present as a key in the authorities argument. 
 * If this key doesn't exist, the button won't be shown and the page hidden.
 * 
 * As children on the .tabContainer, create .tabPages with data-tab-id equal
 * to that of the .tabButton.
 * 
 * 
 * EXAMPLE
 * 
 * html:
 * <div class="tabContainer">
 *    <div class="tabBar">
 *      <button class="tabBarItem" data-tab-id="page1">Page 1</button>
 *      <button class="tabBarItem" data-tab-id="page2">Page 2</button>
 *      <button class="tabBarItem" data-tab-id="page3">Page 3</button>
 *    </div>
 *    <div class="tabPage" data-tab-id="page1">This is page 1</div>
 *    <div class="tabPage" data-tab-id="page2">This is page 2</div>
 *    <div class="tabPage" data-tab-id="page3">This is page 3</div>
 * </div>
 * 
 * 
 * JS:
 * var authorities = {
 *    page1: true,
 *    page2: false,
 *    page3: true
 * }
 * createTabPage(".tabContainer", authorities);
 * 
 * Pages 1 and 3 will be accessible, but not 2.
 */


export function createTabPage(selector, authorities) {

  // initialise elements
  const parent = $(selector);
  const pages = parent.children(".tabPage");
  const tabBar = parent.find(".tabBar");
  const tabBarItems = tabBar.children(".tabBarItem");

  var currentPage = null;

  // initial setup
  $(pages).each((i, page) => {

    // get the tab id and whether this page is authorised
    const tabId = $(page).attr("data-tab-id");
    const hasAuth = authorities[tabId] === true;

    // if not authed, hided the button and the page
    if (!hasAuth) {
      $(tabBarItems[i]).removeClass("active");
      $(tabBarItems[i]).hide();
      $(page).hide();
      return;
    }

    // if we are authed, show the button
    $(tabBarItems[i]).show();

    // if we havent got an initial page yet,
    // set the button to active and show the page
    if (currentPage === null) {
      $(tabBarItems[i]).addClass("active");
      $(page).show();
      currentPage = i;
    } else {
      // else make sure the button isn't active and hide the page
      $(tabBarItems[i]).removeClass("active");
      $(page).hide();
    }
    
  });

  $(tabBarItems).each((i, tabBarItem) => {

    const tabId = $(tabBarItem).attr("data-tab-id");
    const hasAuth = authorities[tabId] === true;

    // remove any existing click events
    $(tabBarItem).off("click");
    
    $(tabBarItem).click(function(e) {

      // if this is the current page or we don't have authority to access
      // this page, don't do anything
      if (!hasAuth) {
        return;
      }

      //switch pages
      $(tabBarItems[currentPage]).removeClass("active");
      $(pages[currentPage]).hide();

      currentPage = i;

      $(tabBarItems[currentPage]).addClass("active");
      $(pages[currentPage]).show();
      
    });

  });
  
  
}

export function createAjaxTabPage(selector, authorities, data = {}, initialTabId = null) {

  // initialise elements
  const parent = $(selector);
  const pages = parent.children(".tabPage");
  const tabBar = parent.find(".tabBar");
  const tabBarItems = tabBar.children(".tabBarItem");

  // Check a tab exists with the given initialTabId if given
  if(initialTabId != null && $('.tabBarItem[data-tab-id="' + initialTabId + '"').length == 0){
    initialTabId = null;
  }

  var currentPage = null;

  // initial setup
  $(pages).each((i, page) => {

    // get the tab id and whether this page is authorised
    const tabId = $(page).attr("data-tab-id");
    const hasAuth = authorities[tabId] === true;
    const tabDisabled = $(tabBarItems[i]).attr("data-tab-disabled") == "1";

    $(tabBarItems[i]).removeClass("active");
    $(tabBarItems[i]).removeClass("disabled");

    // if not authed, hided the button and the page
    if (!hasAuth) {
      $(tabBarItems[i]).removeClass("active");
      $(tabBarItems[i]).hide();
      $(page).hide();
      return;
    }

    // if we are authed, show the button if the tab isn't disabled
    if(! tabDisabled){
      $(tabBarItems[i]).show();
    }

    // if we havent got an initial page yet,
    // set the button to active and show the page
    if ((currentPage == null && initialTabId == null) || tabId == initialTabId) {
      $(tabBarItems[i]).addClass("active");
      $(page).show();
      currentPage = i;
    } else {
      // else make sure the button isn't active and hide the page
      $(tabBarItems[i]).removeClass("active");
      $(page).hide();
      
      if(tabDisabled){
        $(tabBarItems[i]).addClass("disabled");
      }
    }
    
  });

  $(tabBarItems).each((i, tabBarItem) => {

    const tabId = $(tabBarItem).attr("data-tab-id");
    const hasAuth = authorities[tabId] === true;
    const tabDisabled = $(tabBarItem).attr("data-tab-disabled") == "1";
    const tabPageAjaxUrl = $(tabBarItem).attr("data-tab-url");

    // remove any existing click events
    $(tabBarItem).off("click");
    
    if(! tabDisabled){

      var changeTabFunction = function(){
        
        // if this is the current page or we don't have authority to access
        // this page, don't do anything        
        if (!hasAuth) {
          return;
        }
  
        //switch pages
        $(tabBarItems[currentPage]).removeClass("active");
        $(pages[currentPage]).hide();
        
        $(".content", pages[currentPage]).html(``);
        
        /**
         * Sometimes, e.g. due to z-index issues, we need to move some of
         * the content belonging to the tab outside of the tab. We don't
         * want this left around to pollute the page so we search for
         * any of these items and obliterate them.
         */
        $( ".tabContentExternal" ).remove();

  
        $(".content", pages[currentPage]).html(``);

        currentPage = i;
  
        $(".content", pages[currentPage]).html(`<div class="dataLoadingCover" style="">
                                                    <img src="/images/ajax-loader.gif" alt="">
                                                </div>`);
  
        $(tabBarItems[currentPage]).addClass("active");
        $(pages[currentPage]).show();
  
        // Fire off an ajax request to get the page content
        var successCallback = function(data){
          if(data.tabHtml){
            $(".content", pages[currentPage]).html(data.tabHtml);
          }
        };
        
        var errorCallback = function( data ){
          standardAjaxErrorCallback( data );
          // TODO make this look nicer
          var errorContent = "<p>" + Translator.tr( "Something went wrong. Please try reloading the tab." ) + "</p>";          
          $(".content", pages[currentPage]).html(errorContent);
        }

        data.tab = tabId;
  
        standardAjaxPost(tabPageAjaxUrl, data, successCallback, errorCallback, false);
        
      }
      
      $(tabBarItem).click(function(e) {
  
        var result = parent.triggerHandler( "merisis.tab.change", { "confirmFunction": changeTabFunction } );
        
        if ( result === false ){
          return false;
        }
        
        changeTabFunction();
        
      });
    }

  });
  
  
}

// TODO take an id instead of a tab container so we can store funcs by pageIdentifier and tab Id
var tabLeaveEvents = {};

export function addTabLeaveWarning( pageIdentifier, $tabContainer, successCallback = null ){
    
  clearTabLeaveWarning( pageIdentifier, $tabContainer );
  
  var tabChangeFunction = function(event, extraParameters){    
    
    $( "#tabSaveChangesWarningModal" ).modal( 'show' );
    
    $( "#tabSaveChangesWarningModal" ).find( "#tabSaveChangesWarningModalCancel" ).off( "click");
    $( "#tabSaveChangesWarningModal" ).find( "#tabSaveChangesWarningModalSubmit" ).off( "click");
    
    $( "#tabSaveChangesWarningModal" ).find( "#tabSaveChangesWarningModalCancel" ).on( "click", function(){
        $( "#tabSaveChangesWarningModal" ).modal( 'hide' );
    });
    
    $( "#tabSaveChangesWarningModal" ).find( "#tabSaveChangesWarningModalSubmit" ).on( "click", function(){
        var hideFunction = function(){
            $( "#tabSaveChangesWarningModal" ).off( 'hidden.bs.modal', hideFunction );
            clearTabLeaveWarning( pageIdentifier, $tabContainer );
            if ( successCallback != null ){
              successCallback();
            }
            extraParameters.confirmFunction();    
        }
        $( "#tabSaveChangesWarningModal" ).on( 'hidden.bs.modal', hideFunction );
        $( "#tabSaveChangesWarningModal" ).modal( 'hide' );
        
    });
    
    return false;
  };
  
  $tabContainer.on( "merisis.tab.change", tabChangeFunction );    
  
  tabLeaveEvents[ pageIdentifier ] = tabChangeFunction;

}

export function clearTabLeaveWarning( pageIdentifier, $tabContainer ){
  if ( typeof tabLeaveEvents[ pageIdentifier ] !== "undefined" ){
      $tabContainer.off( 'merisis.tab.change', tabLeaveEvents[ pageIdentifier ] );
      delete tabLeaveEvents[ pageIdentifier ];
  }
}